import React from "react";
import { FlightDetailsFareUpgradeDesktopUI } from "../../../../../../ui/FlightDetails/index.js";
import { track } from "@flights/et-universal";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { Stack } from "@bookingcom/bui-react";
export function UpgradeFareInfoDesktop(props) {
    const { headerInline, fareInfoContent } = props;
    const i18n = useI18n();
    if (!fareInfoContent)
        return null;
    return (React.createElement(FlightDetailsFareUpgradeDesktopUI, { header: i18n.trans(t("flights_fd_heading_fare_upgrades")), title: headerInline, content: (React.createElement(Stack, { gap: 0 }, [fareInfoContent.content, fareInfoContent.price].filter(Boolean).map((t, i) => (React.createElement(Stack.Item, { key: i }, t))))), headerWithIcon: track("flights_funnel_new_fd_page_desktop") === 1 }));
}
